import React, { useCallback } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import PersonAddRoundedIcon from '@mui/icons-material/PersonAddRounded';
import EditIcon from '@mui/icons-material/Edit';
import AddAlertIcon from '@mui/icons-material/AddAlert';
import { PersistentSearchHeader } from '../../PersistentSearchHeader';
import { useNavigate } from 'react-router-dom';
import qs from 'qs';

interface HeaderAction {
  icon: React.ReactElement;
  label: string;
  onClick: () => void;
}

interface ClientTableHeaderProps {
  onModifyClients: () => void;
  onCreateReminders: () => void;
  myClients?: boolean;
}

/**
 * Header component for the client table with action buttons
 */
export const ClientTableHeader: React.FC<ClientTableHeaderProps> = ({
  onModifyClients,
  onCreateReminders,
  myClients
}) => {
  const navigate = useNavigate();

  const handleCreateClient = useCallback(() => {
    navigate({
      pathname: '/client/',
      search: qs.stringify({ myClients })
    });
  }, [navigate, myClients]);

  const actions: HeaderAction[] = [
    {
      icon: <PersonAddRoundedIcon />,
      label: 'Kurti klientą',
      onClick: handleCreateClient
    },
    {
      icon: <EditIcon />,
      label: 'Redaguoti klientų sąrašą',
      onClick: onModifyClients
    },
    {
      icon: <AddAlertIcon />,
      label: 'Kurti priminimus',
      onClick: onCreateReminders
    }
  ];

  const renderActions = () => (
    <span>
      {actions.map(({ icon, label, onClick }) => (
        <Tooltip key={label} title={label}>
          <IconButton color="primary" aria-label={label} onClick={onClick} size="large">
            {icon}
          </IconButton>
        </Tooltip>
      ))}
    </span>
  );

  return (
    <PersistentSearchHeader
      title="Klientai"
      actions={renderActions()}
    />
  );
}; 